import { combineReducers } from "redux";

import auth from "./users/auth";
// import settings from "./users/settings";

export default combineReducers({
  auth,
  // settings
});
